export const STATIC_HM_PATH = "/static/hm/";
export const MEDIA_HM_PATH = "/media/hm/";
